import emissionViewStore from "../../../Store/marco/emissionViewStore";
import { emissionFactorAPI } from "../../API/emissionFactorAPI";
import { categoryRouteMap } from "../../services/categoryRouteMap";
import handleAPIError, {
  MESSAGE_CODES,
  showSuccessToast,
} from "../../../services/toast";
const store = emissionViewStore;

//////// 驗證是不是有效的係數
export async function validEF() {
  const { selectedTab, emissionFactorFormData, EFIncertFormData } =
    emissionViewStore;
  const { checkEFAvailable } = emissionFactorAPI;

  const routeCat = categoryRouteMap[selectedTab];
  let cat = routeCat
    ? routeCat.replace(/^cat/, "")
    : selectedTab.split(" ")[0].replace(/^(\d+)\.(\d+)/, "$1_$2"); ////1_1 1_2......

  const response = await checkEFAvailable(
    cat,
    emissionFactorFormData.activityNameId,
    emissionFactorFormData.cId,
    EFIncertFormData.EFId,
  );

  if (response) return response.data[0];
}

//////// 判斷Incert要呼叫哪支修改API
export async function handleEditEF() {
  const {
    selectedTab,
    emissionFactorFormData,
    EFIncertFormData,
    _handleSetEmissionActivityModalLoading,
    _handleSetIsShowEFIncertModal,
    _handleSetEFIncertFormData,
  } = emissionViewStore;
  const { cat4ModifyEmissionFactor } = emissionFactorAPI;

  const routeCat = categoryRouteMap[selectedTab];
  const cat = routeCat ? routeCat.split("_")[0] : `cat${selectedTab.charAt(0)}`;

  _handleSetEmissionActivityModalLoading(true);
  try {
    let response;
    if (cat === "cat4") {
      response = await cat4ModifyEmissionFactor(
        emissionFactorFormData.id,
        EFIncertFormData.EFTypeId,
        EFIncertFormData.EFId,
        EFIncertFormData.landEFTypeId,
        EFIncertFormData.landEFId,
      );
    } else {
      response = await emissionFactorAPI[`${cat}ModifyEmissionFactor`](
        emissionFactorFormData.id,
        EFIncertFormData.EFTypeId,
        EFIncertFormData.EFId,
      );
    }

    if (response?.success === false) {
      handleAPIError(null, { apiData: response, throwError: false });
      return;
    }

    showSuccessToast({
      apiData: response,
      scenarioCode: MESSAGE_CODES.EMISSION_INVENTORY_EF_UPDATE_SUCCESS,
    });
    await store.getEFListData({ keepPage: true });
    _handleSetIsShowEFIncertModal(false);
    _handleSetEFIncertFormData(true);
  } catch (err) {
    console.error(err);
    handleAPIError(err, { throwError: false });
  } finally {
    _handleSetEmissionActivityModalLoading(false);
  }
}

//////// 取得EFList列表
export async function handleIncert(params) {
  const { _handleSetEmissionActivityModalLoading } = emissionViewStore;
}
